import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";
import { Mail, Inbox, Search } from "lucide-react";

export default function BuyerDashboardPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [rfqs, setRfqs] = useState([]);

  useEffect(() => {
    if (loading) return;
    if (!user) { navigate("/login"); return; }
    api.get("/rfqs/sent").then(({ data }) => setRfqs(data));
  }, [user, loading, navigate]);

  if (!user) return null;

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="buyer-dashboard">
      <div className="flex items-center justify-between mb-10">
        <div>
          <div className="tracking-overline mb-3">Buyer dashboard</div>
          <h1 className="font-serif text-3xl md:text-4xl text-[#11211A]">Welcome, {user.name}</h1>
          <p className="text-sm text-[#7D8C85] mt-2">{user.company || user.email}</p>
        </div>
        <Link to="/search" className="btn-primary" data-testid="find-products-btn">
          <Search className="w-4 h-4" /> Find products
        </Link>
      </div>

      <div className="flex items-center gap-2 mb-6 text-sm font-medium text-[#11211A]">
        <Inbox className="w-4 h-4" /> Your sent RFQs ({rfqs.length})
      </div>

      {rfqs.length === 0 ? (
        <div className="bg-[#F0EFEA] p-12 text-center text-[#7D8C85] rounded-sm">
          You haven't sent any RFQs yet. <Link to="/search" className="text-[#264839] hover:underline">Browse suppliers</Link> to send your first quote request.
        </div>
      ) : (
        <div className="space-y-3">
          {rfqs.map((r) => (
            <div key={r.id} className="bg-white border border-[#E8ECE9] p-5" data-testid={`sent-rfq-${r.id}`}>
              <div className="flex items-start justify-between gap-4">
                <div className="min-w-0">
                  <Link to={`/listing/${r.listing_id}`} className="font-serif text-lg text-[#11211A] hover:text-[#264839]">{r.listing_title}</Link>
                  <div className="text-xs text-[#7D8C85] mt-1">
                    Sent to <span className="text-[#11211A]">{r.advertiser_email || "supplier"}</span> · {new Date(r.created_at).toLocaleDateString()}
                  </div>
                </div>
                <span className={`text-[10px] uppercase tracking-[0.2em] px-2 py-1 ${r.email_status === "sent" ? "bg-[#264839] text-white" : "bg-[#E8ECE9] text-[#4A5550]"}`}>
                  {r.email_status}
                </span>
              </div>
              {(r.quantity || r.target_delivery) && (
                <div className="flex gap-4 mt-2 text-xs text-[#4A5550]">
                  {r.quantity && <span>Qty: {r.quantity}</span>}
                  {r.target_delivery && <span>By: {r.target_delivery}</span>}
                </div>
              )}
              <div className="mt-3 text-sm text-[#1C221F] whitespace-pre-wrap line-clamp-3 border-l-2 border-[#264839] pl-4">{r.notes}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
